import React from 'react'
import { useHistory } from '@fs/zion-router'
import { Arrow } from '@fs/zion-icon'
import { useTransition, animated } from '@react-spring/web'
import { useTranslation } from 'react-i18next'
import { Row, IconButton } from '../index'

type Props = {
  children: React.ReactNode
}

export default function DialogOverlayHeaderWithBack({ children }: Props): JSX.Element {
  const [t] = useTranslation()
  const history = useHistory()
  const showBack = history?.index > 0

  const transitions = useTransition(showBack, {
    from: { marginInlineStart: -40, opacity: 0, marginInlineEnd: 0 },
    enter: { marginInlineStart: -0, opacity: 1, marginInlineEnd: 20 },
    leave: { marginInlineStart: -40, opacity: 0, marginInlineEnd: 0 },
  })

  return (
    <Row gutters="nano" guttersY="none" alignY="middle">
      {transitions(
        (styles, item) =>
          item && (
            <animated.div style={styles}>
              <IconButton
                Icon={Arrow}
                iconDirection="backward"
                color="gray"
                onClick={history.goBack}
                title={t('common-ui:back.action', 'Back')}
              />
            </animated.div>
          )
      )}
      {children}
    </Row>
  )
}
